import React from 'react';
import EChartCommon, { getAxisPointer } from '@op/components/EChartCommon';
import { getChartsShowCount } from '@/pages/opinion/utils';
import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';
import { ServerTimeType } from '@/pages/opinion/components/FilterCommon/types';

type EChartsOptions = echarts.EChartsOption;
export default function LineChart({
  tooltipFormatterFunc,
  xAxisData,
  seriesDataArray,
  lineLegendFormatter,
  loading,
  dateType,
  height = 300,
  colorObj,
  isStack,
  title,
  connectNulls = true,
}: {
  tooltipFormatterFunc: (value: any, title?: string) => string;
  xAxisData: Array<any>;
  seriesDataArray: Array<any>;
  lineLegendFormatter?: (value: any) => string;
  loading: boolean;
  dateType: ServerTimeType;
  height: number;
  colorObj?: { [key: string]: string };
  isStack?: boolean;
  title?: string;
  connectNulls?: boolean;
}) {
  // 设置图形配置
  const makeupOptions = () => {
    const seriesData: EChartsOptions['series'] = [];
    const legendData: Array<any> = [];
    seriesDataArray.forEach(({ data, seriesOptions = {}, name }) => {
      let realData = data;
      if (!connectNulls) {
        realData = realData.map((item: any) => (item === 0 ? null : item));
      }
      const seriesItem: any = {
        data: realData,
        type: 'line' as any,
        name: name,
        connectNulls: connectNulls,
        color: colorObj?.[name],
        ...seriesOptions,
      };
      if (isStack) {
        seriesItem['stack'] = 'Total';
        seriesItem['areaStyle'] = {
          opacity: 0.25,
        };
      }
      seriesData.push(seriesItem);
      legendData.push({
        name: name,
        icon: 'circle',
      });
    });

    const opts: EChartsOptions = {
      tooltip: {
        formatter: (param) => tooltipFormatterFunc(param, title),
        position: (pos, params, dom, rect, size) => {
          // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
          const [canvasWidth, canvasHeight] = size.viewSize;
          const [mouseX, mouseY] = pos;
          if (mouseX < canvasWidth / 2) {
            return [mouseX + 10, mouseY / 6];
          }
          return [mouseX - 240, mouseY / 6];
        },
      },
      axisPointer: getAxisPointer((data) => {
        return formatTimeXAxisText(data.value, dateType);
      }),
      legend: {
        data: legendData,
        formatter: (name) => {
          if (lineLegendFormatter instanceof Function) {
            return lineLegendFormatter(name);
          }
          return name;
        },
      },
      xAxis: {
        data: xAxisData,
        boundaryGap: false,
        axisLabel: {
          formatter: (value) => formatTimeXAxisText(value, dateType),
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value) => {
            const data = getChartsShowCount(Math.abs(value), 1);
            return value >= 0 ? data : `-${data}`;
          },
        },
      },
      series: seriesData,
    };

    return opts;
  };

  return (
    <EChartCommon
      options={makeupOptions()}
      loading={loading}
      height={height}
      empty={seriesDataArray?.length === 0}
    />
  );
}
